import React, { Component, Fragment, useState } from "react";
import { withStyles } from "@mui/styles";
import CustomizedSnackbar from "../../../../../components/CustomizedSnackbar/CustomizedSnackbar";
import LoginMenu from "../../../../../components/LoginMenu/LoginMenu";
import {Divider, IconButton, Tooltip, CircularProgress, Grid, Typography, Button,
  Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper, Card,
  CardContent} from "@mui/material";
  import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { format } from "date-fns";
import FilterIcon from "@mui/icons-material/FilterList";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';

import { useDropzone } from "react-dropzone";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import UploadDocumentsTable from './UploadDocumentsTable';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "rgb(29, 95, 152)", //theme.palette.common.black,
    color: theme.palette.common.white,
    fontWeight: 500,
    border: '1px solid white'
  },
  body: {
    fontSize: 14,
    border: '1px solid rgb(29, 95, 152)'
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const styles = ({
  table: {
    width: "100%",
  },
});


function MyDropzone(props) {
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone();

  const files = acceptedFiles.map((file, index) => {
    const size = file.size > 0 ? (file.size / 1000).toFixed(2) : file.size;

    return (
      <Typography key={index} variant="subtitle1" color="primary">
        {file.path} - {size} Kb
        <input type="hidden" name="file_name" value={file.path}></input>
      </Typography>
    )
  });

  let msg = files || [];
  if (msg.length <= 0 || props.files.length <= 0) {
    msg = <Typography variant="subtitle1">
      Please click to select a file or drop your file here
  </Typography>;
  }
  return (
    <div
      style={{ textAlign: "center" }}
      {...getRootProps({ className: "dropzone", onChange: event => props.onChange(event) })}
    >
      <Card style={{ backgroundColor: "#c7c7c7" }}>
        <CardContent style={{
          paddingBottom: 18
        }}>
          <input name="contained-button-file" {...getInputProps()} disabled={props.disabled} />
          {msg}

        </CardContent>
      </Card>
    </div>
  );
}

class F200Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      showTableFilter: false,
      showSearchBar: false,
      isDownloadExcel: false,
      applicationStatusId: 1,
      admissionData: null,
      genderData: [],
      degreeData: [],
      studentName: "",
      genderId: 0,
      degreeId: 0,
      applicationId: "",
      isLoginMenu: false,
      isReload: false,
      eventDate: null,
      isOpenSnackbar: false,
      snackbarMessage: "",
      snackbarSeverity: "",
      files: [],
      documentData: [],
      filesError: "",
      uploadLoading:false,
      popupBoxOpen: false,
      popupBoxFiles: [],
    };
  }

  handleOpenSnackbar = (msg, severity) => {
    this.setState({
      isOpenSnackbar: true,
      snackbarMessage: msg,
      snackbarSeverity: severity,
    });
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({
      isOpenSnackbar: false,
    });
  };

  handleFileChange = event => {
    const { files = [] } = event.target;
    if (files.length==1) {
        if ( (files[0].type === "image/jpeg" || files[0].type === "image/png" || files[0].type === "application/pdf" || files[0].type === "application/msword" || files[0].type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") && files[0].size/1000<10000) {
            this.setState({
                files,
                filesError: ""
            });
        }else {
            this.handleOpenSnackbar("Please select only pdf, doc or docx file with size less than 10 MBs.","error");
        }
    } else {
      this.handleOpenSnackbar("Please select only one file at a time.","error");
    }
  }

  onClearFilters = () => {
    this.setState({
      studentName: "",
      genderId: 0,
      degreeId: 0,
      applicationId: "",
      eventDate: null,
    });
  };

  handleDateChange = (date) => {
    this.setState({eventDate: date});
  };

 

  downloadFile = (e, fileName, viewOnly=false) => {
      e.preventDefault();
      const data = new FormData();
      data.append("fileName", fileName);
      const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/CommonViewFile?fileName=${encodeURIComponent(fileName)}`;
      fetch(url, {
          method: "GET",
          headers: new Headers({
              Authorization: "Bearer "+localStorage.getItem("lmsToken"),
          }),
      })
          .then((res) => {
              if (res.status === 200) {
                  return res.blob();
              } else if (res.status === 401) {
                  this.setState({
                      isLoginMenu: true,
                      isReload: false
                  })
                  return {}
              } else {
                  alert('Operation Failed, Please try again later.');
                  return {}
              }
          })
          .then((result) => {
              if(viewOnly) {
                let fileExtension = fileName.slice((Math.max(0, fileName.lastIndexOf(".")) || Infinity) + 1);
                let fileMimeType = result.type;

              
                if(fileExtension==="doc" || fileExtension==="DOC"){
                  fileMimeType = "application/msword";
                }else if(fileExtension==="pdf" || fileExtension==="PDF") {
                  fileMimeType = "application/pdf"
                }else if(fileExtension==="docx" || fileExtension==="DOCX"){
                  fileMimeType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
                }else if(fileExtension==="png" || fileExtension==="PNG"){
                  fileMimeType = "image/png";
                }
                else if(fileExtension==="jpeg" || fileExtension==="JPEG"){
                  fileMimeType = "image/jpeg";
                }
                let blob = new Blob([result], { type: fileMimeType });
                if (blob) {
                    let fileURL = window.URL.createObjectURL(blob);
                    window.open(fileURL);
                }
              } else {
                let csvURL = window.URL.createObjectURL(result);
                let tempLink = document.createElement("a");
                tempLink.href = csvURL;
                tempLink.setAttribute("download", fileName);
                tempLink.click();
              }
              
              if (result.CODE === 1) {
                  //Code
              } else if (result.CODE === 2) {
                  alert("SQL Error (" +result.CODE +"): " +result.USER_MESSAGE +"\n" +result.SYSTEM_MESSAGE);
              } else if (result.CODE === 3) {
                  alert("Other Error ("+result.CODE+"): " +result.USER_MESSAGE +"\n" +result.SYSTEM_MESSAGE);
              } else if (result.error === 1) {
                  alert(result.error_message);
              } else if (result.success === 0 && result.redirect_url !== "") {
                  window.location = result.redirect_url;
              }
          })
          .catch((error) => {
              console.log(error);
          });
  };

  

  onHandleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  handleToggleTableFilter = () => {
    this.setState({ showTableFilter: !this.state.showTableFilter });
  };

  handleToggleSearchBar = () => {
    this.setState({ showSearchBar: !this.state.showSearchBar });
  };

  isFileValid = () => {
    let isValid = true;
    if (this.state.files.length<1 && this.state.recordId==0) {
      this.handleOpenSnackbar("Please select file.","error");
      isValid = false;
    } else {
      this.setState({ filesError: "" });
    }
    return isValid;
  };

  handleClickOpen = (popupBoxFiles) => {
    this.setState({ 
      popupBoxOpen: true,
      popupBoxFiles: popupBoxFiles
    });
  }

  handleClose = () => {
    this.setState({
      popupBoxOpen: false,
      popupBoxFiles: []
    });
  };

 
  componentDidMount() {
    this.props.setDrawerOpen(false);
    this.loadData();
  }

  loadData = async () => {
    this.setState({
      isLoading: true
    })
    
    await this.getData();

    this.setState({
      isLoading: false
    })
  };

  getData = async () => {
    let url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C200CovidVaccineCertificateDocumentView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (result) => {
          if (result.CODE === 1) {
            this.setState({
              documentData: result.DATA || []
            })
          } else {
            alert(result.SYSTEM_MESSAGE + "\n" + result.USER_MESSAGE)
          }
        },
        (error) => {
          alert("Operation Failed, Please try again later");
          console.log(error);
        }
      );
  };

  isFormValid = () => {
    let { filesError } = this.state;
    let isValid = true;
    
    if (this.state.files.length <= 0) {
      isValid = false;
      filesError = "Please select a file."
    }
    this.setState({
      
      filesError,
      
    })
    return isValid;
  }

  handleSubmitButtonClick = () => {

    
    const isValid = this.isFormValid();
   
    if (isValid) {
     
      document.getElementById("submit-button").click();
    }
    return;
  };

  DownloadFile = (fileName) => {
    const data = new FormData();
    data.append("fileName", fileName);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${
      process.env.REACT_APP_SUB_API_NAME
      }/common/CommonViewFile?fileName=${encodeURIComponent(fileName)}`;

    fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (res.status === 200) {
          return res.blob();
        } else if (res.status == 401) {
          this.setState({
            isLoginMenu: true,
            isReload: false
          })
          return {}
        } else {
          alert('Operation Failed, Please try again later.');
          return {}
        }
      })
      .then((result) => {
        var csvURL = window.URL.createObjectURL(result);
        var tempLink = document.createElement("a");
        tempLink.href = csvURL;
        tempLink.setAttribute("download", fileName);
        tempLink.click();
        console.log(csvURL);
        if (result.CODE == 1) {
          //Code
        } else if (result.CODE == 2) {
          alert(
            "SQL Error (" +
            result.CODE +
            "): " +
            result.USER_MESSAGE +
            "\n" +
            result.SYSTEM_MESSAGE
          );
        } else if (result.CODE == 3) {
          alert(
            "Other Error (" +
            result.CODE +
            "): " +
            result.USER_MESSAGE +
            "\n" +
            result.SYSTEM_MESSAGE
          );
        } else if (result.error == 1) {
          alert(result.error_message);
        } else if (result.success == 0 && result.redirect_url != "") {
          window.location = result.redirect_url;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  deleteFile = (id) => {
    const data = new FormData();
    data.append("documentTypeId", id);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C200CovidVaccineCertificateDocumentDelete`;
    fetch(url, {
      method: "POST",
      body: data,
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (result) => {
          console.log(result);
          if (result["CODE"] == 1) {
            this.loadData();
          } else {
            alert(result.SYSTEM_MESSAGE + "\n" + result.USER_MESSAGE);
          }
        })
      .catch((error) => {
        if (error.status == 401) {
          this.setState({
            isLoginMenu: true,
            isReload: false
          })
        } else {
          alert('Operation Failed, Please try again later.');
          console.log(error);
        }
      });
  };

  handleSubmit = async (e) => {
   
    e.preventDefault();
    const data = new FormData(e.target);
    this.setState({
      isUploading: true,
    });
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C200CovidVaccineCertificateDocumentUpload`;
    await fetch(url, {
      method: "POST",
      body: data,
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then((result) => {
        if (result.CODE == 1) {
          this.setState({
            files: [],
            filesError: "",
            
          })
          this.loadData();
        } else {
          alert(result.CODE + ":" + result.SYSTEM_MESSAGE + "\n" + result.USER_MESSAGE);
        }
      })
      .catch((error) => {
        if (error.status == 401) {
          this.setState({
            isLoginMenu: true,
            isReload: false
          })
        } else {
          alert('Operation Failed, Please try again later.');
          console.log(error);
        }
      });
    this.setState({
      isUploading: false,
    });
  };

  render() {

    const {classes} = this.props;

    

    return (
      <Fragment>
        <LoginMenu
          reload={this.state.isReload}
          open={this.state.isLoginMenu}
          handleClose={() => this.setState({ isLoginMenu: false })}
        />
        <div
          style={{
            padding: 20,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography
              style={{
                color: "#1d5f98",
                fontWeight: 600,
                textTransform: "capitalize",
              }}
              variant="h5"
            >
              <Tooltip title="Back">
                <IconButton onClick={() => window.history.back()} size="large">
                  <ArrowBackIcon fontSize="small" color="primary" />
                </IconButton>
              </Tooltip>
              Covid Vaccine Certificate
            </Typography>
            {/* 
              <img alt="" src={ExcelIcon} onClick={() => this.downloadExcelData()} style={{
                  height: 30, width: 32,
                  cursor: `${this.state.isDownloadExcel ? 'wait' : 'pointer'}`,
               }}
              /> 
            */}
            <div style={{ float: "right" }}>
              
              <Tooltip title="Table Filter">
                <IconButton
                  style={{ marginLeft: "-10px" }}
                  onClick={this.handleToggleTableFilter}
                  size="large">
                  <FilterIcon fontSize="default" color="primary" />
                </IconButton>
              </Tooltip>
            </div>
          </div>
          <Divider
            style={{
              backgroundColor: "rgb(58, 127, 187)",
              opacity: "0.3",
            }}
          />
          <Fragment>
           
            <div
            style={{
              marginTop: "15px",
              marginBottom: "60px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div style={{ width: "96%" }}>
              <form
                id="myform"
                onSubmit={this.handleSubmit}
                autoComplete="off"
              >
                <Grid container spacing={2}>
                  <Grid size={12}>
                    <div style={{ padding: 10 }}>
                      <Typography
                        style={{
                          color: "#1d5f98",
                          fontWeight: 600,
                          fontSize: 20,
                        }}
                        variant="h5"
                      >
                        Upload Certificate
                    </Typography>
                     
                      <br></br>
                      <Typography
                        style={{ fontSize: 14, paddingTop: "20px" }}
                        variant="p"
                      > Please Upload your covid vaccine certificate.

                      </Typography>
                    </div>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={12}
                    style={{ paddingLeft: 20, paddingRight: 20 }}
                  >
                    
                    <div>&nbsp;</div>
                  </Grid>
                  {this.state.documentTypeId == 6 && (
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      style={{
                        paddingLeft: 20,
                        paddingRight: 20,
                        paddingTop: 10,
                        marginTop: '-10px',
                        marginBottom: 20
                      }}
                    >
                     
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={12}
                    sm={11}
                    style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 10 }}
                  >

                    <MyDropzone files={this.state.files} onChange={event => this.handleFileChange(event)} disabled={this.state.isUploading} />
                    <div style={{
                      textAlign: 'center',
                      marginTop: 10
                    }}>
                      <span style={{
                        color: '#ff2d2d'
                      }}>{this.state.filesError}</span>
                    </div>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={1}
                    style={{
                      paddingTop: 10,
                      marginTop: 10,
                    }}
                  >
                    <input
                      id="submit-button"
                      type="submit"
                      style={{ display: "none" }}
                    />
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      className={classes.submit}
                      style={{ width: 75, height: 40 }}
                      onClick={() => this.handleSubmitButtonClick()}
                      disabled={this.state.isUploading || !!this.state.documentData.length}
                    >
                      {this.state.isUploading ? (
                        <CircularProgress style={{ color: "white" }} size={24} />
                      ) : (
                          "Upload"
                        )}
                    </Button>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 10 }}
                  >
                    <UploadDocumentsTable rows={this.state.documentData}
                      columns={[
                        { key: "documentTypeLabel", label: "Document Type", style: { width: '30%' } },
                        { key: "isApproved", label: "Status", style: { width: '30%' } },
                        { key: "uploadedOn", label: "Upload Date", style: { width: '20%' } }
                      ]} onDownload={name => this.DownloadFile(name)} onDelete={id => this.deleteFile(id)} />
                  </Grid>
                 
                
                  
                </Grid>
              </form>
            </div>
          </div>
          <Grid size={12}>
                <div style={{ padding: 10 }}>
                  <br></br>
                  <Typography
                    style={{ fontSize: 14, paddingTop: "20px" }}
                    variant="p"
                  > *Note : If status is Rejected, then please delete present covid vaccine certificate and upload valid covid vaccine certificate again.

                  </Typography>
                </div>
          </Grid>
        </Fragment>
     
         
        </div>
      </Fragment>
    );
  }
}
export default withStyles(styles)(F200Form);
